var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.question_type,_vm._g(_vm._b({tag:"component",staticClass:"question-block__variant",attrs:{"variants":_vm.variants,"name":_vm.name,"question_number":_vm.question_number}},'component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }